<template>

  <div class="main" id="egcf-speaker-main">
    <loading-spinner v-if="isLoading"></loading-spinner>

    <speaker-detail-dialog :get-lang-for-speech="getLangForSpeechById" ref="speakerDetailDialog"></speaker-detail-dialog>
    <template v-if="!isLoading">

      <div class="main-header">
          <div class="search-input-container">
            <input type="search" v-model="searchValue"  spellcheck="false"
                   autocapitalize="none" v-bind:placeholder="$t('search-input-placeholder')"/>
          </div>
      </div>


      <div class="speaker-list">

        <div class="speaker" v-for="speaker of speakers" v-on:click="openSpeakerDetailDialog(speaker,$event)">
          <lazy-load-container>
            <div class="speaker-image" :style="[speaker.hasPicture() ? {'background-image':'url('+ speaker.getPictureUrl()+')'} : {} ]" ></div>
          <div class="speaker-info-container">
            <span class="speaker-name">{{speaker.displayName}}</span>
            <small class="speaker-position">{{speaker.company}}</small>
          </div>
          </lazy-load-container>
        </div>


        <span class="empty-search-results" v-if="searchValue && speakers.length === 0">
           {{$t('empty-search-results')}}
        </span>
      </div>
      <div ref="scrollToTopButton" class="scroll-to-top-button" v-on:click="scrollTop">
        <svg xmlns="http://www.w3.org/2000/svg" fill="white"
             viewBox="0 0 448 512">
          <!-- Font Awesome Pro 5.15.4 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) -->
          <path
            d="M34.9 289.5l-22.2-22.2c-9.4-9.4-9.4-24.6 0-33.9L207 39c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6 0 33.9L413 289.4c-9.5 9.5-25 9.3-34.3-.4L264 168.6V456c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V168.6L69.2 289.1c-9.3 9.8-24.8 10-34.3.4z"/>
        </svg>
      </div>
    </template>
  </div>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component'
import {isDefined, scrollToTop} from "@/utils";
import LazyLoadContainer from "@/components/LazyLoadComponent.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import SpeakerDetailDialog from "@/components/SpeakerDetailDialog.vue";
import {Services} from "@/Services";
import {Speaker} from "@/entities/Speaker";
import {Person, Speech} from "@/entities/Speech";
import {zip} from "rxjs";
import {SpeechFilter} from "@/entities/SpeechFilter";
import { Observable } from "rxjs";
import {Role} from "@/entities/Role";


@Options({components: {SpeakerDetailDialog, LazyLoadContainer, LoadingSpinner}})
export default class App extends Vue {

  private searchValue: string = '';
  private isLoading: boolean = true;
  private _speakers: Speaker[] = [];
  private _visibleSpeakers: Speaker[] = [];
  private _speeches : Speech[] = [];
  private speechFilter: SpeechFilter = new SpeechFilter({});
  roles: Role[] = [];

  constructor(props: any) {
    super(props);

    const observables: Observable<any>[] = [Services.getSpeechFilters(),
      Services.getSpeeches(),
      Services.getSpeakers(),
      Services.getRoles()];

    zip(...observables).subscribe(values => {
      this.speechFilter = values[0];
      this._speeches = values[1];
      this._speakers = values[2];
      this._visibleSpeakers = this._speakers.filter((speaker) => speaker.hasPicture() && !speaker.picture.startsWith('NN_'));
      this.roles = values[3];

      this.isLoading = false;
    });
  }

  mounted() {
    window.addEventListener('scroll', this.handleScrollEvent);
  }

  private handleScrollEvent(): void {
    if (isDefined(this.$refs.scrollToTopButton)) {
      if (document.body.scrollTop > 200 || document.documentElement.scrollTop > 200) {
        (this.$refs.scrollToTopButton as HTMLElement).style.display = "block";
      } else {
        (this.$refs.scrollToTopButton as HTMLElement).style.display = "none";
      }
    }
  }

  private scrollTop(): void {
    scrollToTop();
  }



  private openSpeakerDetailDialog(speaker:Speaker,event:Event) :void{
    event.stopImmediatePropagation()
    if(isDefined(this.$refs.speakerDetailDialog)){
      let speechesForSpeaker: Speech[] = this._speeches.filter(s => s.speakers.find(e => e.id === speaker.id));
      (this.$refs.speakerDetailDialog as SpeakerDetailDialog).openDialog(speaker,speechesForSpeaker,this.roles,this._speakers)
    }
  }

  private getLangForSpeechById(id): string {
    if (isDefined(id) && isDefined(this.speechFilter)) {
      for (const [key, value] of Object.entries(this.speechFilter.filters)) {
        for (const filter of value) {
          if (filter.id === id) {
            return filter.title;
          }
        }
      }
    }
    return undefined;
  }

  get speakers(): Speaker[] {
    if(isDefined(this.searchValue) && this.searchValue.trim().length > 0){
      return this._visibleSpeakers.filter(s => s.hasSearchValue(this.searchValue.trim().toLowerCase()));
    }
    return this._visibleSpeakers;
  }
}
</script>

<style lang="scss">
@use "assets/scss/main";
</style>

<style lang="css">
@import "./assets/css/font-awesome.css";
</style>
